import PaginationComponent from "../../base/pagination.component";
import {MediaPageService} from "./service/media.page.service";
import {InterfaceMedia, InterfaceMediaItem} from "../../interface/press-center/interface.media";
import {MediaBody} from "./media.body";
// import {MediaStore} from "../../store/media.store";
import { currentUrl, numberSystemDecimal, searchParams } from '../../common/consts';

export class MediaPage {
    constructor(
        // private mediaStore: MediaStore,
        private loader: HTMLElement | null,
        private pressCenterMedia: HTMLElement[],
        private totalCount: number,
    ) {
    }
    public initialize(): void {
        const pageContainerMedia: HTMLElement | null = document.querySelector('[data-page-container-media]');

        if (pageContainerMedia) {
            const itemsCountMedia = this.totalCount;
            const itemsOnPageMedia = 6;
            if (this.totalCount <= itemsOnPageMedia) {
                pageContainerMedia.classList.add('hidden');
            } else {
                pageContainerMedia.classList.remove('hidden');
            }
            const pageParam = searchParams.get('pageMedia');
            let startPage = pageParam ? parseInt(pageParam, numberSystemDecimal) : 1;

            if (startPage > Math.ceil(itemsCountMedia / itemsOnPageMedia)) {
                startPage = 1;

                searchParams.set("pageMedia", "1")
                currentUrl.search = searchParams.toString();
                history.pushState(null, '', currentUrl.toString());
                this.setList(1);
            }
            const paginationMedia = new PaginationComponent({
                container: pageContainerMedia,
                maxVisibleElements: 8,
                elementsBetweenDots: 3,
                pageClickCallback: (pageNumber: number) => {
                    this.setList(pageNumber);
                }
            });
            paginationMedia.make(itemsCountMedia, itemsOnPageMedia, startPage);

        }
    }
    private setList(pageNumber: number): void {
        new MediaPageService(this.loader).getMediaByPage(pageNumber)
            .then((data: InterfaceMedia | null) => {
                if (data) {
                    this.pressCenterMedia.forEach((item: HTMLElement) => new MediaBody(
                        item,
                        data.Publications,
                        data.TotalCount,
                        this.loader,

                    ).initialize());
                }
            });
    }
}
